<template>
  <div>
    <borFrame :title="'媒体类型推送情况'" :iconShow="true" @iconClick="echartsShow = !echartsShow">
      <div v-show="echartsShow" class="borFrame_echart" ref="borFrame_echart">
      </div>
      <div v-show="!echartsShow" class="borFrame_content">
        <TableDemo :columns="columns" :data="list"></TableDemo>
      </div>
      <p class="borFrame_content_more">
        2024年03月26日共为您下发系统预警22条，系统预警总量为22条，较于昨日,系统预警增加22条，其中敏感数量22条，中性数量22条，非敏感数量22条。
      <div class="borFrame_content_more_btn">
        查看详情 >
      </div>
      </p>
    </borFrame>
  </div>
</template>
<script>
import borFrame from "@/components/frame";
import TableDemo from "@/components/table";
import * as echarts from 'echarts';
export default {
  name: 'Push',
  components: {
    borFrame,
    TableDemo
  },
  data() {
    return {
      echartsShow: true,
      columns: [
        {
          prop: 'text',
          label: '来源',
          width: '50%',
          align: 'center',
          'min-width': '0.6rem'
        },
        {
          prop: 'num',
          label: '预警数量',
          align: 'center',
          width: '50%',
          'min-width': '0.6rem'
        },
      ],
      list: [
        {
          text: '视频',
          num: '36'
        },
        {
          text: '微博',
          num: '48'
        },
        {
          text: '微信',
          num: '31'
        },
        {
          text: '互动论坛',
          num: '29'
        },
        {
          text: '网站',
          num: '25'
        },
        {
          text: '客户端',
          num: '34'
        },
        {
          text: '数字报',
          num: '18'
        },
      ],
    }
  },
  mounted() {
    this.initEchart();
  },
  methods: {
    initEchart() {
      let myChart = echarts.init(this.$refs.borFrame_echart);
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}:({d}%)',
        },
        legend: [
          {
            bottom: '0',
            itemWidth: 12,
            itemHeight: 12,
            icon: 'circle',
            textStyle: {
              color: '#4E5969',
              fontSize: 12,
              padding: [0, 0, 0, 10],
            },
            data: ['视频', '微博', '微信', '互动论坛', '网站', '客户端', '数字报'],

          }],
        grid: {
          top: '20%', // 图例距离容器上边缘的距离为20px
          left: '50%', // 图例距离容器左边缘的距离为40px
        },
        title: {
          text: `{a| 建筑物 }`,
          textStyle: {
            rich: {
              a: {
                fontSize: 12,
                color: '#1D2129',
              },
            },
          },
          subtext: `{a|分类}`,
          subtextStyle: {
            rich: {
              a: {
                fontSize: 12,
                color: '#1D2129',
                padding: [0, 0, 0, 7],
              },
            },
          },
          x: '42%',
          y: '35%',
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            center: ['50%', '40%'],
            color: [
              '#86DF6C',
              '#249EFF',
              '#0E42D2',
              '#846BCE',
              '#21CCFF',
            ],
            label: {
              position: 'outside',
              show: true,
              color: '#4E5969',
              fontSize: 12,
              formatter: function (params) {
                if (params.name !== '') {
                  return params.percent + '%';
                }
              },
            },
            labelLine: {
              show: true,
              length2: 10,
              length: 5,
            },
            itemStyle: {
              normal: {
                borderWidth: 2,
                borderColor: '#fff',
              },
            },
            data: [
              { value: '36', name: '视频' },
              { value: '48', name: '微博' },
              { value: '31', name: '微信' },
              { value: '29', name: '数字报' },
              { value: '25', name: '互动论坛' },
              { value: '34', name: '网站' },
              { value: '18', name: '客户端' },
            ],
          },
        ],
      }
      myChart.setOption(option);
    },
  }
}
</script>
<style lang="less" scoped>
.borFrame_echart {
  width: 100%;
  height: 3rem;


}

.borFrame_content_more {
  background: #f8f8f8;
  letter-spacing: 1px;
  line-height: 1.5;
  margin-top: .1rem;

  &_btn {
    margin-top: .1rem;
    color: #9a9494;
    font-size: .14rem;
    text-align: right;
  }
}
</style>